import * as React from "react";

import { NavUser } from "@/src/pages/study/components/layout/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  SidebarSeparator,
} from "@/components/ui/sidebar";
import { SidebarGroup } from "@/components/ui/sidebar";
import { SidebarGroupLabel } from "@/components/ui/sidebar";
import { HighlightPanel } from "./highlights/highlight-panel";
import { RecentHighlights } from "./highlights/recent-highlights";
import { AutoCollapseSidebar } from "./auto-collapse-sidebar";
import { useNotebookContext } from "../../hooks/useNotebook";
import { Info, Library } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Separator } from "@/components/ui/separator";
import {
  ThreadListItemPrimitive,
  ThreadListPrimitive,
} from "@assistant-ui/react";
import { ThreadList } from "@/components/assistant-ui/thread-list";

export function SidebarRight({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const { currentPage, highlights } = useNotebookContext();
  return (
    <Sidebar collapsible="icon" side="right" className="" {...props}>
      <AutoCollapseSidebar
        shouldCollapse={
          currentPage.type === "source" ||
          currentPage.type === "source_highlight" ||
          currentPage.type === "source_highlight_category"
        }
      />
      <SidebarRail />
      {/* <SidebarHeader className="border-sidebar-border h-16 border-b">
        
      </SidebarHeader> */}
      <SidebarContent>
        {/* <DatePicker /> */}
        <SidebarGroup className="pb-0">
          <div className="flex items-center group-data-[collapsible=icon]:flex-col group-data-[collapsible=icon]:w-full">
            <SidebarGroupLabel className="text-sm py-6">
              <span className="group-data-[collapsible=icon]:hidden">
                Saved Materials
              </span>
            </SidebarGroupLabel>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-3.5 w-3.5 text-theme-1 group-data-[collapsible=icon]:mb-4" />
                </TooltipTrigger>
                <TooltipContent side="right">
                  <p className="max-w-xs text-xs">
                    Create study materials (flashcards, quizzes, and more) from
                    the buttons in the chat panel!
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="px-1">
            <Separator className="mb-2 h-px rounded-full" />
          </div>
          <HighlightPanel />
        </SidebarGroup>
        {/* <Calendars calendars={data.calendars} /> */}
        <SidebarGroup className="pt-1 pb-0">
          {highlights.length ? (
            <SidebarGroupLabel className="text-xs font-bold">
              Recently Created
            </SidebarGroupLabel>
          ) : null}
          <RecentHighlights />
        </SidebarGroup>
        <SidebarGroup className="pt-0">
          <SidebarGroupLabel className="text-xs font-bold">
            Recent Chats
          </SidebarGroupLabel>
          <ThreadList />
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
